import React, {Component} from 'react';
import axios from 'axios';

import TypeProfile from '../type-profile';
import TypeWindow from '../type-window';
import MainArea from '../main-area';
import Complex from '../complex';
import Price from '../price';
// import Modal from '../modal';

import '../modal/modal.scss';


// Типы профилей
let profileData = [],
	typeWindowData = [],
	salesData = [],
	priceFurnituraData = {};

//windowsLeaf и typeWindowData связаны через позицию в массиве windowsLeaf и поле id в typeWindowData.
export default class App extends Component{
	state = {
		window_width : 0,
		window_height : 0,
		currentTypeWindowId : 1,
		currentWindowLabel : '',
		currentCountWindows : 1,
		currentProfileId : 1,
		storeOptions : [],
		salePercent : 0,
		saleCountWindow: 1,
		windowsTypeLeaf: [],
		valute : '',
		error: null,
		isLoaded: false
	}

	componentDidMount = () => {
		// console.log('componentDidMount');
		axios.get('/calcdata.json')
			.then(response => {
				const data = response.data;
				const newState = data.state;
				const idx = data.typeWindowData.findIndex((el) => el.id === newState.currentTypeWindowId);
				const root = document.querySelector('#root');

				if (root.getAttribute('data-currentprofileid')){
					newState.currentProfileId = parseInt(root.dataset.currentprofileid)
				}


				typeWindowData =  data.typeWindowData;
				profileData = data.profileData;
				salesData = data.salesData;
				priceFurnituraData = data.priceFurnituraData;


				// setDataState(data);
				newState.window_width = typeWindowData[idx].xInitialValue || 0;
				newState.window_height = typeWindowData[idx].yInitialValue || 0;
				newState.currentWindowLabel = typeWindowData[idx].label || '';
				newState.currentCountWindows = typeWindowData[idx].countWindows || 1;
				newState.isLoaded = true;
				newState.storeOptions = data.storeOptions;

				this.setState(newState);
			})
			.catch(error => {
				// handle error
				console.log(error);
				this.setState({
					isLoaded: true,
					error
				});
			})
			.then(function () {
				// always executed
			});
	}


	componentDidUpdate = () =>{
		const {currentWindowLabel, currentProfileId, currentTypeWindowId, window_width, window_height, saleCountWindow, windowsTypeLeaf, currentCountWindows, storeOptions} = this.state;
		// const form = document.querySelector('#wincalc-modal .wincalc-form');

		// Тип окна
		document.querySelector('#currentWindowLabel').textContent = currentWindowLabel;
		document.querySelector('.form-actions input[name="currentWindowLabel"]').value = currentWindowLabel;

		// Тип профиля
		const idxCurrentProfileId = profileData.findIndex( el => el.id === currentProfileId);
		const typeProfile = profileData[idxCurrentProfileId].label;
		document.querySelector('#profilelabel').textContent = typeProfile;
		document.querySelector('.form-actions input[name="profilelabel"]').value = typeProfile;

		// Ширина
		document.querySelector('#window_width').textContent = window_width;
		document.querySelector('.form-actions input[name="window_width"]').value = window_width;

		// Высота
		document.querySelector('#window_height').textContent = window_height;
		document.querySelector('.form-actions input[name="window_height"]').value = window_height;

		// Количество окон
		document.querySelector('#countwindow').textContent = saleCountWindow;
		document.querySelector('.form-actions input[name="saleCountWindow"]').value = saleCountWindow;

		if (currentTypeWindowId === 5) {
			document.querySelector('#wincalc-modal .order-row-countwindow').classList.add('d-none')
		} else{
			document.querySelector('#wincalc-modal .order-row-countwindow').classList.remove('d-none')
		}

		// Тип открывания
		let typesLeafs = windowsTypeLeaf
			.slice(0, currentCountWindows)
			.map(function(el) {
				let result = '';
				switch (el) {
					case 'g':
						result = 'Глухая створка';
						break;
					case 'p':
						result = 'Поворотная створка';
						break;
					case 'o':
						result = 'Поворотно-откидная створка';
						break;
					default:
						break;
				}
				return result;
			})
			.join(', ');

		document.querySelector('#typesLeafs').textContent = typesLeafs;
		document.querySelector('.form-actions input[name="typesLeafs"]').value = typesLeafs;


		// Услуги
		const options = storeOptions
			.filter(el => el.check)
			.map(el => el.label)
			.join(', ');
		document.querySelector('#options').textContent = options;
		document.querySelector('.form-actions input[name="options"]').value = options;

		(options.length > 0) ? document.querySelector('#wincalc-modal .order-row-options').classList.remove('d-none') : document.querySelector('#wincalc-modal .order-row-options').classList.add('d-none');
	}

	render(){
		const PATH_IMAGES = '/calculator/images/';
		const { error, isLoaded } = this.state;

		if (error) {
			return <div>Ошибка: {error.message}</div>;
		} else if (!isLoaded) {
			return <div className="wincalc-loading">Загрузка...</div>;
		} else {
			return (
				<React.Fragment>
					<div className="wincalc d-lg-grid grid-xl-2">
						<TypeProfile
							currentProfileId = {this.state.currentProfileId}
							profiledata={profileData}
							onChangeTypeProfile = {this.changeTypeProfile}
						/>

						<TypeWindow
							mainstate = {this.state}
							typewindowdata = {typeWindowData}
							onUpdateTypeWindow = {this.updateTypeWindow}
							pathimages = {PATH_IMAGES}
						/>

						<MainArea
							mainstate = {this.state}
							typewindowdata = {typeWindowData}
							onUpdateHeight = {this.updateHeight}
							onUpdateWidth = {this.updateWidth}
							onUpdateWindowsLeaf = {this.updateWindowsLeaf}
							pathimages = {PATH_IMAGES}
						/>
						<Complex
							mainstate={this.state}
							salesdata={salesData}
							typewindowdata={typeWindowData}
							onUpdateWidth={this.updateWidth}
							onUpdateHeight = {this.updateHeight}
							onChangeOptionCheckbox = {this.changeOptionCheckbox}
							onChangeSale = {this.changeSale}
						/>
						<Price
							mainstate = {this.state}
							profiledata = {profileData}
							typewindowdata = {typeWindowData}
							pricefurnitura = {priceFurnituraData}
						/>
					</div>
					{/* <Modal
						mainstate = {this.state}
						profiledata = {profileData}
					/> */}
				</React.Fragment>
			);
		}
	}

	updateTypeWindow = (id) =>{
		const idx = typeWindowData.findIndex((el) => el.id === id),
			  currentWindow = typeWindowData[idx],
			  currentWindowLabel = typeWindowData[idx].label,
			  currentCountWindows = typeWindowData[idx].countWindows;

		this.setState({
			currentTypeWindowId : id,
			currentWindowLabel,
			currentCountWindows,
			window_width : currentWindow.xInitialValue,
			window_height : currentWindow.yInitialValue
		});

		this.showhidePrice(this.state.saleCountWindow, id);
	}

	updateWidth = (value) => {
		const idx = typeWindowData.findIndex((el) => el.id === this.state.currentTypeWindowId),
			  currentWindow = typeWindowData[idx];

		if (value <  currentWindow.xmin || value >  currentWindow.xmax) {
			document.querySelector('#wincalc-size-x').classList.add('error');
		} else {
			document.querySelector('#wincalc-size-x').classList.remove('error')
		}

		this.setState({window_width: value});
	}

	updateHeight = (value) => {
		const idx = typeWindowData.findIndex((el) => el.id === this.state.currentTypeWindowId),
			  currentWindow = typeWindowData[idx];

		if (value <  currentWindow.ymin || value >  currentWindow.ymax) {
			document.querySelector('#wincalc-size-y').classList.add('error');
		} else {
			document.querySelector('#wincalc-size-y').classList.remove('error')
		}

		this.setState({window_height: value});
	}

	changeOptionCheckbox = (id) => {
		const cloneStoreOptions = [...this.state.storeOptions];
		cloneStoreOptions[id].check = !cloneStoreOptions[id].check;
		this.setState({storeOptions: cloneStoreOptions});
	}

	changeTypeProfile = (id) => {
		this.setState({
			currentProfileId : id
		})
	}

	changeSale = (value, count) => {
		this.setState({
			salePercent : value,
			saleCountWindow : count
		});
		this.showhidePrice(count);
	}

	updateWindowsLeaf = (idTypeWindowData, value) =>{
		// узнаем индекс окна для выбранной створки в массиве typeWindowData
		// Этот индекс соответствует позиции ячейчки в windowsLeaf в state
		const idx = [...typeWindowData].findIndex(el => el.id === idTypeWindowData);
		const cloneWindowsLeaf = [...this.state.windowsTypeLeaf];
		cloneWindowsLeaf[idx] = value;

		this.setState({
			windowsTypeLeaf : cloneWindowsLeaf
		})
	}

	showhidePrice = ( count, id ) => {
		const priceEl = document.querySelector('.price-block'),
			  wincalcBtn = document.querySelector('.wincalc-button');

		if (count === 5 && id !==5) {
			// если количество окон 5 или больше
			priceEl.style.display = 'none';
			wincalcBtn.textContent = 'Заказать окна';
			wincalcBtn.classList.add('ml0');
		} else {
			priceEl.style.display = 'block';
			wincalcBtn.textContent = 'Связь с менеджером';
			wincalcBtn.classList.remove('ml0');
		}
	}
}


